module angular.ui {
    export interface IStateGen<TStateResolve extends IViewStateResolve> extends IState {
        resolve?: TStateResolve;
    }

    export interface IState extends ng.ui.IState   {
        /**
        * The url used to match route with dg-link href.
        */
        apiUrl?: string;

        modalOptions?: dg.modals.IModalOptions;

        allowAnonymous?: boolean;

    }

    export interface IViewStateResolve {
        viewId?: (...args: any[]) => string | ng.IPromise<string>;
        viewCssClass?(...args: any[]): string | ng.IPromise<string>;
        queryParams?: (...args: any[]) => any | ng.IPromise<any>;
    }

    //export interface IStateProvider {
    //    state<TStateResolve>(name: string,
    //        config: IStateGen<TStateResolve>): IStateProvider;
    //}
}
